import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCamera = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 4C11.6656 4 11.3534 4.1671 11.1679 4.4453L9.46482 7H6C5.20435 7 4.44129 7.31607 3.87868 7.87868C3.31607 8.44129 3 9.20435 3 10V24C3 24.7957 3.31607 25.5587 3.87868 26.1213C4.44129 26.6839 5.20435 27 6 27H26C26.7957 27 27.5587 26.6839 28.1213 26.1213C28.6839 25.5587 29 24.7957 29 24V10C29 9.20435 28.6839 8.44129 28.1213 7.87868C27.5587 7.31607 26.7957 7 26 7H22.5352L20.8321 4.4453C20.6466 4.1671 20.3344 4 20 4H12ZM10.8321 8.5547L12.5352 6H19.4648L21.1679 8.5547C21.3534 8.8329 21.6656 9 22 9H26C26.2652 9 26.5196 9.10536 26.7071 9.29289C26.8946 9.48043 27 9.73478 27 10V24C27 24.2652 26.8946 24.5196 26.7071 24.7071C26.5196 24.8946 26.2652 25 26 25H6C5.73478 25 5.48043 24.8946 5.29289 24.7071C5.10536 24.5196 5 24.2652 5 24V10C5 9.73478 5.10536 9.48043 5.29289 9.29289C5.48043 9.10536 5.73478 9 6 9H10C10.3344 9 10.6466 8.8329 10.8321 8.5547ZM12.5 16.5C12.5 14.567 14.067 13 16 13C17.933 13 19.5 14.567 19.5 16.5C19.5 18.433 17.933 20 16 20C14.067 20 12.5 18.433 12.5 16.5ZM16 11C12.9624 11 10.5 13.4624 10.5 16.5C10.5 19.5376 12.9624 22 16 22C19.0376 22 21.5 19.5376 21.5 16.5C21.5 13.4624 19.0376 11 16 11Z",
		fill: "black"
	})
});
export default SvgCamera;
